import { FC, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import TextInput from "../../components/TextInput";
import ConnexionLayout from "../../components/ConnexionLayout";
import { AuthContext } from "../../contexts/AuthContext";
import Button from "../../components/Button";

import "./style.css";

const Login: FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { login } = useContext(AuthContext)!;

    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState(location.state?.email || "");
    const [password, setPassword] = useState("");
    // const [error, setError] = useState<string | null>(null); // Pour les erreurs globales
    const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>(
        {}
    ); // Pour les erreurs par champ

    const handleLogin = async () => {
        setIsLoading(true);
        // setError(null);
        setFieldErrors({}); // Réinitialiser les erreurs spécifiques

        try {
            await login(email, password);
        } catch (err: any) {
            if (err.response && err.response.data) {
                if (err.response.data.errors) {
                    // Structurer les erreurs spécifiques aux champs
                    const errors = err.response.data.errors.reduce(
                        (acc: any, curr: any) => {
                            acc[curr.field] = curr.message;
                            return acc;
                        },
                        {}
                    );
                    setFieldErrors(errors);
                } else {
                    // Gérer les erreurs globales
                    // setError(
                    //     err.response.data.message || "Une erreur est survenue."
                    // );
                }
            } else {
                // setError("Impossible de se connecter au serveur.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ConnexionLayout>
            <p className="connexion_card_title">Bienvenue !</p>
            <p className="connexion_card_subtitle">
                Connecte-toi pour accéder au site.
            </p>
            <div className="login_form_inputs">
                <TextInput
                    label="Email"
                    placeholder="Ton adresse e-mail"
                    value={email}
                    setValue={setEmail}
                    error={fieldErrors.email}
                />
                <TextInput
                    label="Mot de passe"
                    type="password"
                    placeholder="Ton mot de passe"
                    value={password}
                    setValue={setPassword}
                    error={fieldErrors.password}
                />
            </div>
            <p
                className="login_forgotPassword"
                onClick={() =>
                    navigate("/forgot-password", { state: { email } })
                }
            >
                Mot de passe oublié ?
            </p>
            {isLoading ? (
                <CircularProgress className="login_loader" size={45} />
            ) : (
                <Button label="Se connecter" onClick={handleLogin} />
            )}
        </ConnexionLayout>
    );
};

export default Login;
